import { ticketServiceApi } from "../../../app/superAdmin/ticketServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  DashboardGraphDataResponse,
  DashboardParams,
  GetAllTicketsCountResponseType,
  GetCountApprovedParamsType,
  GetCountApprovedResponseType,
  GetDashboardCommonParamsType,
  GetDashboardDataResponseType,
  GetDashboardGraphDataParamsType,
  GetDashboardGraphDataResponseType,
  GetDashboardSatesResponseType,
  GetTicketCountByRoleResponseType,
  GetTicketCountByStatusResponseType,
  GetTicketRaisedWithTimeResponseType,
  GetTopPerformersResponseType,
  MyDepartmentStatesResponse,
} from "../../../types/dashboard";

export const dashboardApi = ticketServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTicketCount: builder.query<
      GetAllTicketsCountResponseType,
      GetQueryArgsType<GetDashboardCommonParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllTicketCount,
        ...queryArgs,
      }),
    }),
    getTicketCountByStatus: builder.query<
      GetTicketCountByStatusResponseType,
      GetQueryArgsType<GetDashboardCommonParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTicketCountByStatus,
        ...queryArgs,
      }),
    }),
    getTicketCountByRole: builder.query<GetTicketCountByRoleResponseType, void>(
      {
        query: () => ({
          url: API_URL.getTicketCountByRole,
        }),
      },
    ),
    getTicketRaisedWithTime: builder.query<
      GetTicketRaisedWithTimeResponseType,
      GetQueryArgsType<GetDashboardCommonParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTicketRaisedWithTime,
        ...queryArgs,
      }),
    }),
    getDashboardData: builder.query<GetDashboardDataResponseType, void>({
      query: () => ({
        url: API_URL.getDashboardData,
      }),
    }),
    getTopPerformers: builder.query<
      GetTopPerformersResponseType,
      GetQueryArgsType<{ toDate?: string; fromDate?: string }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTopPerformers,
        ...queryArgs,
      }),
    }),
    getCountApproved: builder.query<
      GetCountApprovedResponseType,
      GetQueryArgsType<GetCountApprovedParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getCountApproved,
        ...queryArgs,
      }),
    }),
    getAverageCompletion: builder.query<
      GetCountApprovedResponseType,
      GetQueryArgsType<GetCountApprovedParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAverageCompletion,
        ...queryArgs,
      }),
    }),
    getDashboardGraphData: builder.query<
      GetDashboardGraphDataResponseType,
      GetQueryArgsType<GetDashboardGraphDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardGraphData,
        ...queryArgs,
      }),
    }),
    dashboardSates: builder.query<
      GetDashboardSatesResponseType,
      GetQueryArgsType<DashboardParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.states,
        ...queryArgs,
      }),
    }),
    dashboardSatesByClick: builder.query<
      GetDashboardSatesResponseType,
      GetQueryArgsType<DashboardParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.statesByClick,
        ...queryArgs,
      }),
    }),
    dashboardOrganizationSates: builder.query<
      GetDashboardSatesResponseType,
      GetQueryArgsType<DashboardParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.organizationStates,
        ...queryArgs,
      }),
    }),
    dashboardGraphData: builder.query<
      DashboardGraphDataResponse,
      GetQueryArgsType<DashboardParams & { period?: string }>
    >({
      query: (queryArgs) => ({
        url: API_URL.graphData,
        ...queryArgs,
      }),
    }),

    // New API's
    getMyDepartmentTicketStates: builder.query<
      MyDepartmentStatesResponse,
      GetQueryArgsType<DashboardParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMyDepartmentStates,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useDashboardSatesQuery,
  useDashboardSatesByClickQuery,
  useDashboardGraphDataQuery,
  useGetAllTicketCountQuery,
  useGetTicketCountByStatusQuery,
  useGetDashboardDataQuery,
  useGetTicketCountByRoleQuery,
  useGetTicketRaisedWithTimeQuery,
  useGetTopPerformersQuery,
  useGetCountApprovedQuery,
  useGetAverageCompletionQuery,
  useGetDashboardGraphDataQuery,

  // New API's
  useGetMyDepartmentTicketStatesQuery,
  useDashboardOrganizationSatesQuery,
} = dashboardApi;
